import { A as AriaAttr } from './p-d7c3b756.js';

var BxfChatBubbleType;
(function (BxfChatBubbleType) {
    BxfChatBubbleType["USER"] = "user";
    BxfChatBubbleType["RESPONSE"] = "response";
    BxfChatBubbleType["ACTIVE_RESPONSE"] = "active-response";
})(BxfChatBubbleType || (BxfChatBubbleType = {}));

var BxfChatBubbleUserFeedback;
(function (BxfChatBubbleUserFeedback) {
    BxfChatBubbleUserFeedback["POSITIVE"] = "positive";
    BxfChatBubbleUserFeedback["NEGATIVE"] = "negative";
    BxfChatBubbleUserFeedback["NONE"] = "none";
})(BxfChatBubbleUserFeedback || (BxfChatBubbleUserFeedback = {}));

const BxfChatBubbleConstants = {
    CLASS_NAME_CONSTANTS: {
        CHAT_BUBBLE: 'bxf-chat-bubble',
        CONTAINER: 'bxf-chat-bubble__container',
        CONTENT_CONTAINER: 'bxf-chat-bubble__content-container',
        CONTENT_CONTAINER_ICON: 'bxf-chat-bubble__content-container--icon',
        CHAT_BUBBLE_USER_INITIALS_CONTAINER: 'bxf-chat-bubble__user-initials',
        CHAT_BUBBLE_USER_RESPONSE_ICON_CONTAINER: 'bxf-chat-bubble__response-icon-container',
        CHAT_BUBBLE_USER_RESPONSE_SPARKLE_ICON_CONTAINER: 'bxf-chat-bubble__response-icon-container--sparkle',
        FOOTER: 'bxf-chat-bubble__footer',
        FEEDBACK_TEXT_AREA: 'bxf-chat-bubble__feedback-text-area',
        FEEDBACK_CONTAINER: 'bxf-chat-bubble__feedback-container',
        FEEDBACK_LABEL_CONTAINER: 'bxf-chat-bubble__feedback-container--label',
        FEEDBACK_REQUIRED_CONTAINER: 'bxf-chat-bubble__feedback-required-message',
        FEEDBACK_BUTTON_ROW_CONTAINER: 'bxf-chat-bubble__feedback-button-row--container',
        FOLLOW_UP_HEADER_CONTAINER: 'bxf-chat-bubble__follow-up--header',
        FOLLOW_UP_HEADER_CONTAINER_DISABLED: 'bxf-chat-bubble__follow-up--header--disabled',
        FOLLOW_UP_CONTAINER: 'bxf-chat-bubble__follow-up',
        FOLLOW_UP_BUTTON_GROUP_CONTAINER: 'bxf-chat-bubble__follow-up--button-group',
        FOLLOW_UP_BUTTON_CONTAINER: 'bxf-chat-bubble__follow-up--button',
        SIMILAR_QUESTIONS_CONTAINER: 'bxf-chat-bubble__similar-questions',
        SIMILAR_QUESTIONS_BUTTON_CONTAINER: 'bxf-chat-bubble__similar-questions--button',
        SIMILAR_QUESTIONS_BUTTON_GROUP_CONTAINER: 'bxf-chat-bubble__similar-questions--button-group',
        SIMILAR_QUESTIONS_HEADER_CONTAINER: 'bxf-chat-bubble__follow-up--header',
        DISABLED_CARD_TEXT: 'bxf-chat-bubble__disabled-card-text',
        GENERATING_RESPONSE_TEXT: 'bxf-chat-bubble__generating-response-text',
        CARD_GROUP_CONTAINER: 'card-group__container',
        CARD_GROUP_WIDTH_HEIGHT: 'standard-card-group-custom-width-height',
        CARD_GROUP_STACKED: 'standard-card-group-custom-width-height--stacked',
        ACTION_BUTTON_CONTAINER: 'bxf-chat-bubble__action-button--container',
        TIMESTAMP: 'bxf-chat-bubble__timestamp',
        TIMESTAMP_RIGHT_ALIGN: 'bxf-chat-bubble__timestamp--right-align',
        CONTENT_SLOT_WRAPPER: 'bxf-chat-bubble__content--slot-wrapper',
        CONTENT_SLOT_WRAPPER_EMPTY: 'bxf-chat-bubble__content--slot-wrapper-empty',
        TEXT_AREA_CONTAINER: 'bxf-chat-bubble__text-area--container',
        ADDITIONAL_FEEDBACK_FORM: 'bxf-chat-bubble__additional-feedback-form',
        FOOTER_FEEDBACK_PANEL: 'bxf-chat-bubble__footer--feedback-panel',
        FOOTER_FEEDBACK_PANEL_EMPTY: 'bxf-chat-bubble__footer--feedback-panel--empty',
        FEEDBACK_PANEL_EXPANDED: 'bxf-chat-bubble__feedback-panel--expanded',
        STANDARD_FONT: 'bxf-chat-bubble__standard-font',
        FEEDBACK_CONFIRMATION_CONTAINER: 'bxf-chat-bubble__feedback-confirmation--container',
        FEEDBACK_CONFIRMATION_MESSAGE: 'bxf-chat-bubble__feedback-confirmation--container--message',
        GENERATING_TEXT: 'bxf-chat-bubble__process-text',
        GENERATING_ELLIPSES: 'bxf-chat-bubble__process-ellipse',
        LOADING_TEXT_CONTENT: 'loading-text-content',
        LOADING_TEXT_ARIA: 'loading-text-aria',
    },
    SLOT_CONSTANTS: {
        SLOT_CONTENT: 'content',
        SLOT_SOURCES: 'sources',
        SLOT_FEEDBACK: 'feedback',
    },
    DIALOG: {
        SOURCES: 'Explore Sources',
        FEEDBACK_HEADER: 'How helpful was this response?',
        FEEDBACK_CHECKBOX_HEADER: 'What could be better about this response?',
        FEEDBACK_LABEL: 'Did you find this helpful?',
        FEEDBACK_MESSAGE: 'Thanks for your feedback.',
        FEEDBACK_REQUIRED: 'Please provide feedback above to continue',
        FEEDBACK_CONFIRMATION: 'Thank you, your feedback has been submitted.',
        FOLLOW_UP_HEADER: 'Follow Up',
        SIMILAR_QUESTIONS_HEADER: 'Similar Questions',
        COPY: 'Copy',
        ADDITIONAL_FEEDBACK_LABEL: 'How can we improve this response?',
        ADDITIONAL_FEEDBACK_PLACEHOLDER: 'What went wrong?',
    },
    ARIA_LABELS: {
        FEEDBACK_ARIA_LABEL: 'Close thank you message',
        THUMBS_UP_ARIA_LABEL: 'Thumbs up response',
        THUMBS_DOWN_ARIA_LABEL: 'Thumbs down response',
        FOLLOW_UP_QUESTION_ARIA_LABEL: 'Follow up question',
        SIMILAR_QUESTION_ARIA_LABEL: 'Similar question',
    },
};

const { ARIA_LABELS } = BxfChatBubbleConstants;
const DismissFeedbackAriaConfig = {
    [AriaAttr.LABEL]: ARIA_LABELS.FEEDBACK_ARIA_LABEL,
};
const ThumbsUpAriaConfig = {
    [AriaAttr.LABEL]: ARIA_LABELS.THUMBS_UP_ARIA_LABEL,
};
const ThumbsDownAriaConfig = {
    [AriaAttr.LABEL]: ARIA_LABELS.THUMBS_DOWN_ARIA_LABEL,
};

export { BxfChatBubbleType as B, DismissFeedbackAriaConfig as D, ThumbsUpAriaConfig as T, BxfChatBubbleUserFeedback as a, BxfChatBubbleConstants as b, ThumbsDownAriaConfig as c };
